import { AxiosInstance } from 'axios';
import i18next from 'i18next';

export class CertificatesService {
  private axiosInstance: AxiosInstance;
  constructor(axiosInstance: AxiosInstance) {
    this.axiosInstance = axiosInstance;
  }

  downloadCertificatePdf = async (level: string) => {
    const response = await this.axiosInstance.get(`/api/certificate-pdf/${level}`, {
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      responseType: 'blob',
    });

    if (response.data) {
      if (response.status === 400) {
        return {
          status: 'error',
          data: JSON.parse(await response.data.text()),
        };
      } else if (response.status === 200 && response.data.type === 'application/pdf') {
        return { status: 'success', data: response.data };
      }
    }
    throw Error(i18next.t('DownloadCertificateError', { level: level, ns: 'certificate' }));
  };

  download = async (level: string) => {
    try {
      await this.downloadCertificatePdf(level).then((response) => {
        if (response.status === 'error') {
          return;
        }
        const href = window.URL.createObjectURL(response.data);

        const anchorElement = document.createElement('a');

        anchorElement.href = href;
        anchorElement.download = `Trackman-Certificate-${level}`;
        anchorElement.style.display = 'none';

        document.body.appendChild(anchorElement);
        anchorElement.click();

        document.body.removeChild(anchorElement);
        window.URL.revokeObjectURL(href);
      });
    } catch (ex) {
      throw Error('Error');
    }
  };
}
